module.exports = __webpack_public_path__ + "img/linkedin.835c2e6b.svg";